import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { canAccessAdminPanel } from "../utils/permissions";
import Layout from "../components/Layout";

export default function Admin() {
  const { userType } = useContext(AuthContext);
  
  // Check if user has admin access
  if (!canAccessAdminPanel(userType)) {
    return (
      <Layout>
        <div className="p-4 flex items-center justify-center h-full">
          <div className="text-xl text-gray-500">
            You need admin privileges to access this page.
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="p-4 max-w-4xl mx-auto">
        <h1 className="text-3xl font-serif mb-6">Admin Panel</h1>
        
        <div className="bg-white rounded-lg shadow-sm p-8 space-y-6">
          <div>
            <h2 className="text-xl font-medium mb-4">User Management</h2>
            <p className="text-gray-500">
              Manage users, assign roles, and control permissions.
            </p>
          </div>
          
          <div>
            <h2 className="text-xl font-medium mb-4">Content Management</h2>
            <p className="text-gray-500">
              Review, edit, and moderate all published content.
            </p>
          </div>
          
          <div>
            <h2 className="text-xl font-medium mb-4">Site Settings</h2>
            <p className="text-gray-500">
              Configure site-wide settings and appearance.
            </p>
          </div>
          
          <div>
            <h2 className="text-xl font-medium mb-4">Analytics</h2>
            <p className="text-gray-500">
              View detailed site analytics and user engagement metrics.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
}